module.exports = __webpack_public_path__ + "static/media/lifestyle3-large.d759dca0.jpg";